var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGitlab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94803 2.25181C6.26627 2.22972 6.56367 2.41135 6.68933 2.70457L9.49452 9.25001H14.5054L17.3106 2.70457C17.4363 2.41135 17.7337 2.22972 18.0519 2.25181C18.3702 2.27391 18.6396 2.4949 18.7235 2.80267L21.7235 13.8027C21.8032 14.0948 21.6994 14.4061 21.4604 14.592L12.4604 21.592C12.1896 21.8027 11.8104 21.8027 11.5395 21.592L2.53952 14.592C2.30052 14.4061 2.19674 14.0948 2.2764 13.8027L5.2764 2.80267C5.36034 2.4949 5.62978 2.27391 5.94803 2.25181ZM6.15772 5.27204L3.85511 13.715L12 20.0499L20.1448 13.715L17.8422 5.27204L15.6893 10.2955C15.5711 10.5712 15.3 10.75 15 10.75H8.99997C8.69995 10.75 8.4288 10.5712 8.31062 10.2955L6.15772 5.27204Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default __webpack_public_path__ + "static/media/gitlab.b7af6fec04e66b1d0f0190a40e92d538.svg";
export { ForwardRef as ReactComponent };